import React from 'react';
import { Table, Button, Input, Icon, Card, Dropdown, Menu, Modal, message, Popconfirm, Form, Upload } from 'antd';
import common from '../../assets/common.js';
import './index.css';

const FormItem = Form.Item;

class Add extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };
  componentWillMount(){

  }
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this_.submit(values);
      }
    });
  }
  submit = (values) => {
    let postData = values;
    postData["_url"] = 'api/construct/user';
    postData["_method"] = 'POST';
    common.request(postData, this, function(obj, result){
      message.info("创建成功");
      window.location.href = "#/builder";
    },function(obj, data){
      message.warning(data.message);
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {xs: { span: 24 },sm: { span: 6 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    let orgLogo = this.state.orgLogo;
    return (
      <Card>
        <Form onSubmit={this.handleSubmit} style={{maxWidth: 1020}}>
          <FormItem
            {...formItemLayout}
            label="姓名"
          >
            {getFieldDecorator('realName', {
              rules: [{
                required: true, message: '请填写施工人员姓名!',
              }],
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="账号"
          >
            {getFieldDecorator('userName', {
              rules: [{
                required: true, message: '请填写施工人员账号!',
              }],
            })(
              <Input type="text" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="密码"
          >
            {getFieldDecorator('passWord', {
              rules: [{
                required: true, message: '请填写施工人员密码!',
              }],
            })(
              <Input type="text" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="部门"
          >
            {getFieldDecorator('deptName', {
              rules: [{
                required: true, message: '请填写施工人员所在部门!',
              }],
            })(
              <Input type="text" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="备注"
          >
            {getFieldDecorator('remark', {
              rules: [{
                message: '请填写备注!',
              }],
            })(
              <Input type="text" />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">提交</Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}
const addFrom = Form.create()(Add);
export default addFrom;



// WEBPACK FOOTER //
// ./src/component/builder/add.js